<template>
  <div :class="formGroupClass">
    <slot name="before"/>
    <label :for="inputId" class="control-label">{{ inputLabel }}</label>
    <div class="input-group document-validity-period-block">
      <div class="col-md-4 document-validity-period-input">
        <date-picker
          :id="inputId"
          :disabled="disabled"
          :value-type="dateValueType"
          :format="dateFormat"
          :disabled-date="isDisabledDate"
          v-model="inputValue"
          v-facade="dateMask"
          @input="emitValue('input', $event)"
          @change="emitValue('change', $event)"
          @blur="emitValue('change', $event)"
        />
      </div>
      <button
        v-if="showAcceptButton"
        type="button"
        class="btn btn-success btn-primary-white col-md-2"
        @click="acceptDateOfExpire"
      >Подтвердить
      </button>
      <button
        v-if="showCancelButton"
        type="button"
        class="btn btn-danger btn-primary-white col-md-2"
        @click="cancelDateOfExpire"
      >Отменить
      </button>
    </div>
    <error-help-block :has-errors="hasInputErrors" :current-error="actualErrorMessage"/>
    <slot name="after"/>
  </div>
</template>

<script>
import { ApiClient } from '@/common/helpers/api-client/ApiClient'
import applicationInputMixin from '@/common/mixins/applicationInputMixin'
import applicationFormMixin from '@/common/mixins/applicationFormMixin'
import datePickerConfigMixin from '@/common/mixins/application-form/datePickerConfigMixin'
import { UserRoles } from '@/common/enums/UserRoles'
import moment from 'moment'

export default {
  name: 'DocumentValidityPeriodInput',

  mixins: [
    applicationInputMixin,
    applicationFormMixin,
    datePickerConfigMixin
  ],

  props: {
    inputLabel: {
      default: 'Срок действия документа'
    },

    inputName: {
      default: 'date_of_expire'
    },
    document: {
      type: [Object, Array],
      required: true,
      default: () => []
    },

    entityType: {
      type: String,
      required: true
    },

    entityId: {
      required: true
    },

    documentId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      checked: this.document.meta.checked
    }
  },

  computed: {
    inputId() {
      return 'date_of_expire_input'
    },

    userIsSB() {
      return this.user.role === UserRoles.SB
    },

    showAcceptButton() {
      if (this.isView) {
        return (this.userIsSB && (Number(this.checked) === 0))
      }

      return false
    },

    showCancelButton() {
      if (this.isView) {
        return (this.userIsSB && (Number(this.checked) === 1))
      }

      return false
    }
  },

  methods: {
    acceptDateOfExpire() {
      const dateOfExpire = moment(this.document.meta.date_of_expire, this.dateFormat)

      ApiClient.documentUpdate({
        accept: true,
        date_of_expire: dateOfExpire.isValid() ? dateOfExpire.format('YYYY-MM-DD') : this.document.meta.date_of_expire,
        entity_type: this.entityType,
        document_id: this.documentId,
        entity_id: this.entityId
      })
        .then(result => {
          this.checked = 1
          this.$emit('updateParentChecked', 1)
        })
    },

    cancelDateOfExpire() {
      const dateOfExpire = moment(this.document.meta.date_of_expire, this.dateFormat)

      ApiClient.documentUpdate({
        accept: false,
        date_of_expire: dateOfExpire.isValid() ? dateOfExpire.format('YYYY-MM-DD') : this.document.meta.date_of_expire,
        entity_type: this.entityType,
        document_id: this.documentId,
        entity_id: this.entityId
      })
        .then(result => {
          this.checked = 0
          this.$emit('updateParentChecked', 0)
        })
    }
  }
}
</script>
